import axios from "axios";
const BASIC_API = process.env.REACT_APP_BASIC_API + "/CompanyManagement";

const getToken = () => {
    try {
        const data = JSON.parse(localStorage.getItem("biodnd_admin_token"));
        return data?.token || "";
    } catch {
        return "";
    }
};

const authHeaders = () => ({
    headers: { Authorization: `Bearer ${getToken()}` }
});

class CompanyService {
    // ==================== 既有 CRUD ====================

    create(data) {
        return axios.post(`${BASIC_API}`, { data }, authHeaders());
    }

    search(name, page, size = 10, filters = {}) {
        return axios.post(`${BASIC_API}/Search`, {
            name,
            reviewStatus: filters.reviewStatus || null,
            hasPendingMembers: filters.hasPendingMembers || null,
            region: filters.region || null,
            pageRequestParameter: {
                isReturnAllDataAndNoPage: false,
                targetPage: page,
                showCount: size
            }
        }, authHeaders());
    }

    update(companyId, data) {
        return axios.put(`${BASIC_API}/${companyId}`, { data }, authHeaders());
    }

    getDetails(companyId) {
        return axios.get(`${BASIC_API}/${companyId}`, authHeaders());
    }

    delete(companyId) {
        return axios.delete(`${BASIC_API}/${companyId}`, authHeaders());
    }

    // ==================== 審核管理 ====================

    /**
     * 更新公司審核狀態
     * @param {string} uuid
     * @param {string} newStatus - "Active" | "Inactive" | "Pending"
     */
    updateReviewStatus(uuid, newStatus) {
        return axios.put(`${BASIC_API}/${uuid}/ReviewStatus`, { newStatus }, authHeaders());
    }

    /**
     * 審核通過成員
     * @param {string} uuid - 公司 UUID
     * @param {number} memberId
     * @param {boolean} addDomainToVerified - 是否將網域加入驗證清單
     */
    approveMember(uuid, memberId, addDomainToVerified = true) {
        return axios.put(`${BASIC_API}/${uuid}/ApproveMember`, {
            memberId,
            addDomainToVerified
        }, authHeaders());
    }

    /**
     * 拒絕成員
     * @param {string} uuid - 公司 UUID
     * @param {number} memberId
     */
    rejectMember(uuid, memberId) {
        return axios.put(`${BASIC_API}/${uuid}/RejectMember`, { memberId }, authHeaders());
    }

    /**
     * 指派 Creator
     * @param {string} uuid - 公司 UUID
     * @param {number} memberId
     */
    promoteCreator(uuid, memberId) {
        return axios.put(`${BASIC_API}/${uuid}/PromoteCreator`, { memberId }, authHeaders());
    }

    // ==================== Teams & Activity ====================

    /**
     * 取得公司成員列表
     * @param {string} uuid - 公司 UUID
     */
    getTeams(uuid) {
        return axios.get(`${BASIC_API}/${uuid}/Teams`, authHeaders());
    }

    updateMemberNote(uuid, memberId, note) {
        return axios.put(`${BASIC_API}/${uuid}/MemberNote`, { memberId, note }, authHeaders());
    }

    /**
     * 取得公司活動紀錄
     * @param {string} uuid - 公司 UUID
     */
    getActivity(uuid) {
        return axios.get(`${BASIC_API}/${uuid}/Activity`, authHeaders());
    }

    // ==================== Settings ====================

    getSettings() {
        return axios.get(`${BASIC_API}/Settings`, authHeaders());
    }

    updateSettings(data) {
        return axios.put(`${BASIC_API}/Settings`, data, authHeaders());
    }
}

const NewCompanyService = new CompanyService();
export default NewCompanyService;
